package org.vreo.devicehub.features.deviceDetails.domain

import org.vreo.devicehub.features.core.domain.DataError
import org.vreo.devicehub.features.core.domain.EmptyResult
import org.vreo.devicehub.features.core.domain.Result
import org.vreo.devicehub.features.core.domain.device.device.AnprDevice

/**
 * Device details access and view repository. Allows to view selected devices details
 */
interface DeviceDetailsRepository {
    /**
     * Get device's details
     *
     * @param token user authentication token
     * @param deviceId device ID
     * @return Result of device details as [AnprDevice] on success or error on failure
     */
    suspend fun getDeviceDetails(
        token: String,
        deviceId: String
    ): Result<AnprDevice, DataError.Remote>

    /**
     * Update selected device's details
     *
     * @param token user authentication token
     * @param details device details to persist
     * @return Result of empty on success or error on failure
     */
    suspend fun updateDeviceDetails(
        token: String,
        details: AnprDevice
    ): EmptyResult<DataError.Remote>

    /**
     * Unlink the selected device from the current user's account. The device itself is not
     * deleted and remains available to be linked again.
     *
     * @param token user authentication token
     * @param deviceId device ID to unlink
     * @return Result of empty on success or error on failure
     */
    suspend fun unlinkDevice(
        token: String,
        deviceId: String
    ): EmptyResult<DataError.Remote>

    /**
     * Permanently delete the selected device from the production device registry. Unlike
     * [unlinkDevice], this removes the device entirely rather than just detaching it from the
     * current user's account.
     *
     * @param token user authentication token
     * @param deviceId device ID to delete
     * @return Result of empty on success or error on failure
     */
    suspend fun deleteDeviceFromProduction(
        token: String,
        deviceId: String
    ): EmptyResult<DataError.Remote>
}